import { OutcomeStatus, SectionReviewState, SectionValueView } from "generated/graphql";
import { stripNull } from "helpers/coll";
import { useAppSelector } from "redux/hooks";
import { selectMyUserId } from "redux/slices/session";

const outcomeStatusSortValues = {
  [OutcomeStatus.Unreviewed]: 0,
  [OutcomeStatus.DiscrepantInformation]: 10,
  [OutcomeStatus.MissingInformation]: 20,
  [OutcomeStatus.PendingRecords]: 30,
  [OutcomeStatus.NotApplicable]: 40,
  [OutcomeStatus.Rejected]: 50,
  [OutcomeStatus.Valid]: 60,
};

export const sortedOutcomeStatuses = Object.values(OutcomeStatus).toSorted((a, b) => {
  const sortA = outcomeStatusSortValues[a] ?? Number.MAX_SAFE_INTEGER;
  const sortB = outcomeStatusSortValues[b] ?? Number.MAX_SAFE_INTEGER;
  return sortA - sortB;
});

export function useSectionValues(sectionValues: SectionValueView[]) {
  const me = useAppSelector(selectMyUserId);
  const completedSections = sectionValues.filter((sv) => sv.reviewState === SectionReviewState.Complete);
  const reviewSections = sectionValues.filter((sv) => sv.reviewState === SectionReviewState.Review);
  const qaSections = sectionValues.filter((sv) => sv.reviewState === SectionReviewState.Validation);
  const allSectionIds = sectionValues.map((sv) => sv.sectionId);
  const pendingMyReview = reviewSections.filter((sv) => sv.outcomeAssignee === me);
  const pendingMyQA = qaSections.filter(
    (sv) => sv.reviewState === SectionReviewState.Validation && sv.validationAssignee === me
  );
  const unassignedSections = sectionValues.filter(
    (sv) =>
      (sv.reviewState === SectionReviewState.Validation && stripNull(sv.validationAssignee) === undefined) ||
      (sv.reviewState === SectionReviewState.Review && stripNull(sv.outcomeAssignee) === undefined)
  );
  const getSections = (): string => {
    const tasks: string[] = [];
    if (reviewSections.length > 0) tasks.push(`${reviewSections.length} Review`);
    if (qaSections.length > 0) tasks.push(`${qaSections.length} QA`);
    if (completedSections.length > 0) tasks.push(`${completedSections.length} Complete`);
    return tasks.length > 0 ? tasks.join(", ") : `None`;
  };

  return {
    completedSections,
    reviewSections,
    qaSections,
    pendingMyReview,
    pendingMyQA,
    unassignedSections,
    getSections,
    allSectionIds,
  };
}
